import { NoData, Pending, useErrorState } from '@finbeat/react-toolkit';
import { getMerchantStatistic } from 'axios/merchantApi';
import Money from 'components/Common/Money';
import useApi from 'hooks/useApi';
import { MerchantStatisticType } from 'models/api/merchant';
import { useState } from 'react';
import { Trans } from 'react-i18next';
import { useQuery } from 'react-query';
import { Card, CardBody, CardHeader } from 'reactstrap';

const MerchantStatistic = () => {
    const api = useApi();
    const { handleRequestError } = useErrorState();

    const [statistic, setStatistic] = useState<MerchantStatisticType>();

    const { isFetching, isError, isFetched } = useQuery('merchantStatistic',
        () => getMerchantStatistic(api),
        {
            onSuccess: (data) => setStatistic(data),
            onError: (err) => handleRequestError(err),
        }
    );

    return (
        <Card className="mb-3">
            <CardHeader>
                <h6>
                    <Trans i18nKey="BackOfficeMerchantStatistic" />
                </h6>
            </CardHeader>
            <CardBody>
                {isFetching && <Pending />}
                {isFetched && (
                    <dl>
                        <dt>
                            <Trans i18nKey="BackOfficeSaleCount" />
                        </dt>
                        <dd>{statistic?.totalCount}</dd>
                        <dt>
                            <Trans i18nKey="BackOfficeSaleSum" />
                        </dt>
                        <dd>
                            <Money value={statistic?.totalSum} />
                        </dd>
                        <dt>
                            <Trans i18nKey="BackOfficeSaleAvg" />
                        </dt>
                        <dd>
                            <Money value={statistic?.avg} />
                        </dd>
                    </dl>
                )}
                {isError && (
                    <div className="text-center p-3">
                        <Trans i18nKey="BackOfficeCantLoadMerchantContacts" />
                    </div>
                )}
                {!isFetching && !isFetched && !isError && <NoData />}
            </CardBody>
        </Card>
    );
};

export default MerchantStatistic;
